import {useQuery} from "@tanstack/react-query";
import {airportsGet} from "../api/airports/airportsGet.ts";

export const useAirports = (includeIntl?: boolean) => useQuery({
    queryKey: ['airports', includeIntl],
    queryFn: () => airportsGet(includeIntl).then(r => r.payload)
})